<p-toast></p-toast>
<app-lista [columns]="columns" [items]="items" [totalRecords]="totalRecords" [recordName]="recordName" [name]="name" [pluralName]="pluralName"
    [loading]="loading" [modulo]="modulo" [codigoRegistro]="codigoRegistro"
    (getItems)="loadItems()" (create)="onCreate()" (edit)="onEdit($event)"   (export)="onExport()" [cargando]="cargando">
</app-lista>
